var map = {
	"./1.png": 792,
	"./2.png": 793,
	"./3.png": 794,
	"./4.png": 795,
	"./5.png": 796,
	"./6.png": 797,
	"./7.png": 798,
	"./8.png": 799,
	"./avatar/1.png": 482,
	"./avatar/2.png": 483,
	"./avatar/3.png": 484,
	"./avatar/4.png": 485,
	"./avatar/5.png": 486,
	"./avatar/6.png": 487,
	"./avatar/7.png": 488,
	"./avatar/8.png": 489,
	"./ei_board.png": 378,
	"./ei_example.png": 380,
	"./ei_step.png": 379,
	"./scenario.png": 169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 481;